import { defineStore } from "pinia";
import Services from '@/services/martyrDataServices'
import { mapMartyrData } from '@/helpers/mapFuncs'

export const useMartyrDataStore = defineStore("martyrData", {

state:()=>({
    martyrData: {},
    martyrsData: [],
}),
getters : {
    getMartyrData() {
        return mapMartyrData(this.martyrData)
    },
    getMartyrsData() {
        return this.martyrsData.map(mapMartyrData)
    }
},
actions : {
    /** Start Sets */
    setMartyrData(martyrData) {
        this.martyrData = martyrData
    },
    setMartyrsData(martyrsData) {
        this.martyrsData = martyrsData
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setMartyrData(response.data)
            return response
        })
    },
    getByPersonId(personId) {
        return Services.getByPersonId(personId)
        .then((response)=>{
            this.setMartyrData(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setMartyrsData(response.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.martyrsData.push(response.data)
            return mapMartyrData(response.data.data)
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.martyrsData[this.martyrsData.findIndex((x)=>x.id == id)] = response.data
            return mapMartyrData(response.data.data)
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.martyrsData = this.martyrsData.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
